import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ClickOutside from "../ClickOutside";
import { IoSettingsSharp } from "react-icons/io5";
import { IoLogOut } from "react-icons/io5";
import { IoIosArrowDown, IoMdSettings } from "react-icons/io";

const DropdownUser = ({ userName }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    // sessionStorage.removeItem("authToken");
    sessionStorage.removeItem("userName");
    setDropdownOpen(false);
    navigate("/signin", { replace: true });
    window.location.reload();
  };

  return (
    <ClickOutside onClick={() => setDropdownOpen(false)} className="relative ">
      <div className="flex items-center gap-3">
        <Link
          onClick={() => setDropdownOpen(!dropdownOpen)}
          className="flex items-center gap-2"
          to="#"
        >
          <span className=" text-right lg:block">
            <span className="block text-sm font-medium text-black">
              {userName || "Guest"}
            </span>
          </span>
          <IoIosArrowDown />
        </Link>
        <button onClick={() => navigate("/settings/user-master")}>
          <IoMdSettings className="w-5 h-5" />
        </button>
      </div>
      {dropdownOpen && (
        <div
          className={`absolute right-0 mt-4 flex w-62.5 z-1 flex-col rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark`}
        >
          <ul className="flex flex-col gap-5 px-6 py-7.5 ">
            <li>
              <Link
                to="/settings/user-master"
                className="flex items-center gap-3.5 text-sm font-medium duration-300 ease-in-out hover:text-primary lg:text-base"
              >
                <IoSettingsSharp className="w-[18px] h-[18px]" />
                Account Settings
              </Link>
            </li>
          </ul>
          <button
            onClick={handleLogout}
            className="flex items-center gap-3.5 px-6 pb-4 text-sm font-medium duration-300 ease-in-out hover:text-primary lg:text-base"
          >
            <IoLogOut className="w-[18px] h-[18px]" />
            Log Out
          </button>
        </div>
      )}
    </ClickOutside>
  );
};

export default DropdownUser;
